module.exports = __webpack_public_path__ + "static/logo_targt-b3ca9cf9fe6e26c8c7049fde4577153b.svg";